import React, { useState } from 'react'
import { Button, IconButton, Box, Typography, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemIcon, ListItemSecondaryAction, List, Tooltip } from '@material-ui/core'
import { fade, makeStyles } from '@material-ui/core/styles';
import * as RFIcon from 'react-feather'; 
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import FacebookIcon from '@material-ui/icons/Facebook';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import language from '../../languages';

const useStyles = makeStyles((theme) => ({
    title: {
        flexGrow: 1,
        padding: '8px 16px',
        color: '#2735A4',
        backgroundColor: '#F3F6FF',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    actionArea: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    saveButton: {
        color: '#ffffff',
        backgroundColor: '#3076CA',
        '&:hover': {
            backgroundColor: fade('#3076CA', 0.75),
        },
        // margin: '8px 8px;', 
        alignSelf: 'center',
        height: 'fit-content',
        textTransform: 'capitalize'
    },
    cancelButton: {
        margin: '8px 8px;',
        textTransform: 'capitalize'
    },
    titleText: {
        '& .MuiListItemText-primary': {
            color: '#09205C',
            fontWeight: 'bold'
        },
        '& .MuiListItemText-secondary': {
            color: '#09205C'
        }
    },
    linkText: {
        color: '#2367D9'
    },
    infoText: {
        color: '#000000',
        fontWeight: 'bold'
    },
    infoTextValue: {
        marginLeft: 8
    },
    deleteTitle:{
        padding: '8px 16px',
        color: '#ffffff',
        backgroundColor: '#2735A4',
    },
    deleteButton: {
      color: '#2735A4',
      margin: '8px 8px;',
      textTransform: 'capitalize',
      borderColor: '#2735A4'
    },
    deleteConfirmButton: {
        color: '#ffffff',
        backgroundColor: '#3076CA',
        '&:hover': {
          backgroundColor: fade('#3076CA', 0.75),
        },
        margin: '8px 8px;',
        textTransform: 'capitalize'
    },
}));

function BaseSidePanel(props) {
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteRow, setDeleteRow] = useState(null);
    const classes = useStyles();
    const { doc, hideDetail, onDelete, onEdit, lang } = props

    const subStr = (str, limit) => {
        return (str && str.length > limit) ? str.substring(0,limit)+'...' : str
    }
    const longNote = subStr(doc.note, 80)

    return (
        <React.Fragment>
            {
                <ConfirmationDialog
                    dialogProps={{
                        open: deleteDialogOpen,
                        onClose: () => { },
                    }}
                    content={
                        <>
                        <div className={classes.deleteTitle}><Typography variant="h6" >{language[lang].Delete}</Typography></div>
                        <Box p={4} width='600px'>
                            <Box p={2} >
                            <Typography variant="subtitle2" >{language[lang].Confirm_Message} {props.meta.entityName}?</Typography>
                            </Box>
                        </Box>
                        </>
                    }
                    dismissiveAction={<Button variant="outlined" className={classes.deleteButton} onClick={() => { setDeleteRow(null); setDeleteDialogOpen(false) }}>{language[lang].Cancel}</Button>}
                    confirmingAction={<Button variant="contained" className={classes.deleteConfirmButton}  onClick={() => { onDelete(deleteRow); setDeleteDialogOpen(false) }}>{language[lang].Delete}</Button>}
                />
            }
            <Box className={classes.title}>
                <Typography variant="subtitle2" noWrap>
                    {language[lang].Details}
                </Typography>
                <div className={classes.actionArea}>
                    <Tooltip title={language[lang].Delete} placement="bottom">
                        <IconButton size='small' variant="outlined" component="span" onClick={() => { setDeleteRow(doc); setDeleteDialogOpen(true); }}>
                            <RFIcon.Trash2 strokeWidth={2} color='#DE4646' />
                        </IconButton> 
                    </Tooltip>
                    <Button size='small' variant='contained' className={classes.saveButton} onClick={() => onEdit(doc)}>Edit</Button>
                    <Tooltip title={language[lang].Close} placement="bottom">
                        <IconButton size='small' component="span" onClick={hideDetail}><RFIcon.X strokeWidth={2} color='#000000' /></IconButton>
                    </Tooltip>
                </div>
            </Box>
            <Box>
              <List>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar alt={doc.name} src={doc.profileImageUrl} />
                    </ListItemAvatar>
                    <ListItemText className={classes.titleText} primary={doc.name} secondary={doc.phoneNumber} />
                </ListItem>
                <ListItem dense>
                    <ListItemIcon>
                        <RFIcon.MapPin strokeWidth={2} color='#000000' />
                    </ListItemIcon>
                    <ListItemText primary={doc.location} />
                </ListItem>
                <ListItem dense>
                    <ListItemIcon>
                        <RFIcon.DollarSign strokeWidth={2} color='#000000' />
                    </ListItemIcon>
                    <ListItemText primary={doc.coins} />
                </ListItem>
                <ListItem>
                    <ListItemText className={classes.titleText} primary={language[lang].Additional_Information} />
                </ListItem>
                {/* <ListItem dense>
                    <ListItemIcon>
                        <Typography className={classes.infoText} variant="subtitle2" noWrap>
                            {language[lang].Category}
                        </Typography>
                    </ListItemIcon>
                    <ListItemText className={classes.infoTextValue} primary={doc.adCategory} />
                </ListItem> */}
                <ListItem dense>
                    <ListItemIcon>
                        <Typography className={classes.infoText} variant="subtitle2" noWrap>
                            {language[lang].Status}
                        </Typography>
                    </ListItemIcon>
                    <ListItemText className={classes.infoTextValue} primary={doc.isActiveText} />
                </ListItem>
                <ListItem dense>
                    <ListItemIcon>
                        <Typography className={classes.infoText} variant="subtitle2" noWrap>
                            {language[lang].Note}
                        </Typography>
                    </ListItemIcon>
                    <ListItemText className={classes.infoTextValue} primary={longNote} />
                </ListItem>
              </List>
            </Box>
        </React.Fragment>
    )
}

export default BaseSidePanel
